import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

export default function MedicineDetails({ id, onClose }) {
  const [medicine, setMedicine] = useState(null);
  const [loading, setLoading] = useState(true);

  // ✅ API Base URL from env
  const API_BASE_URL = process.env.REACT_APP_API_URL;
  const BASE_IMG = API_BASE_URL?.replace('/api/', '');

  useEffect(() => {
    if (!id) return;

    const fetchMedicine = async () => {
      try {
        setLoading(true);

        console.log("🧪 MEDICINE ID:", id);

        // ✅ Using env URL
        const res = await axios.get(
          `${API_BASE_URL}Medicine/GetMedicineById?id=${id}`
        );

        console.log("📦 RESPONSE:", res.data);

        setMedicine(res.data || null);
      } catch (error) {
        console.error("❌ Error:", error);
        setMedicine(null);
      } finally {
        setLoading(false);
      }
    };

    fetchMedicine();
  }, [id, API_BASE_URL]);

  // ================= LOADING =================
  if (loading) {
    return (
      <div className="fixed inset-0 bg-black/30 flex items-center justify-center z-50">
        <div className="w-10 h-10 border-4 border-red-500 border-t-transparent rounded-full animate-spin"></div>
      </div>
    );
  }

  if (!medicine) return null;

  return (
    <>
      {/* OVERLAY */}
      <div
        className="fixed inset-0 bg-black/40 z-40"
        onClick={onClose}
      />

      {/* DRAWER */}
      <div
        className="fixed top-0 right-0 h-full w-[90%] sm:w-[420px] bg-white z-50 shadow-xl overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        {/* HEADER */}
        <div className="p-4 border-b sticky top-0 bg-white z-10 flex justify-between items-center">
          <h4 className="font-semibold text-red-600">
            Medicine Details
          </h4>

          <button
            onClick={onClose}
            className="text-xl font-bold"
          >
            ✕
          </button>
        </div>

        {/* CONTENT */}
        <div className="p-4 space-y-4">

          {/* NAME */}
          <h5 className="text-lg font-semibold text-center">
            {medicine.product}
          </h5>

          {/* IMAGE */}
          <div className="flex justify-center">
            <img
              src={
                medicine.image
                  ? `${BASE_IMG}/MedicineImage/${medicine.image
                      ?.trim()
                      .replace(/\s/g, "%20")}`
                  : "https://placehold.co/150x150"
              }
              alt={medicine.product}
              className="h-[160px] object-contain bg-gray-50 p-2 rounded"
            />
          </div>

          {/* PRICE */}
          <div className="text-center">
            {medicine.mrpPrice && (
              <span className="line-through text-gray-400 mr-2">
                ₹{medicine.mrpPrice}
              </span>
            )}

            <span className="text-green-600 font-bold text-xl">
              ₹{medicine.salePrice}
            </span>
          </div>

          {/* DETAILS */}
          <div className="text-sm text-gray-600 space-y-2">
            <p>
              <strong>Expiry:</strong>{" "}
              {medicine.expiry
                ? medicine.expiry.split("T")[0]
                : "N/A"}
            </p>

            <p>
              <strong>Store:</strong> {medicine.storeId}
            </p>

            {medicine.description && (
              <p>{medicine.description}</p>
            )}
          </div>

          {/* BACK BUTTON */}
          <Link
            to={`/get-medicine-by-store/${medicine.storeId}`}
            className="block text-center bg-red-500 text-white py-2 rounded"
          >
            Back to Store
          </Link>
        </div>
      </div>
    </>
  );
}